import { render, staticRenderFns } from "./StoreReviewsCarousel.vue?vue&type=template&id=cf1e1cde&scoped=true"
import script from "./StoreReviewsCarousel.vue?vue&type=script&lang=js"
export * from "./StoreReviewsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1e1cde",
  null
  
)

export default component.exports